<template>
  <div class="homeBox" v-show="showStatus" style="display: none;">
    <Header :colorType='colorType' :pageType='pageType' :productType='productType' class="header"></Header>
    <div class="content">
      <Productcenterbanner></Productcenterbanner>
      <ProductModel></ProductModel>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Productcenterbanner from '@/components/productCenter/productcenterbanner'
import ProductModel from '@/components/productCenter/productModel'
import Footer from '@/components/footer/Footer'
export default {
  name: 'Productcenter',
  data: function () {
    return {
      showStatus: false,
      colorType: '3',
      pageType: 'product',
      productType: 1
    }
  },
  components: {
    Header,
    Productcenterbanner,
    ProductModel,
    Footer
  },
  mounted: function () {
    this.showStatus = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.content{
  margin-top: 120px;
  min-width: 1300px;
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter/Productcenter.vue